const ASSET_PATH = process.env.ASSET_PATH;

export default function cdnAsset(path) {

  if (!ASSET_PATH) {
    return path;
  }

  return ASSET_PATH + path.replace(/^\/+/, '')
}
